import React from 'react';
import ReactDOM from 'react-dom';
import { createStore, applyMiddleware } from 'redux';
import { Provider } from 'react-redux';
import createSagaMiddleware from 'redux-saga';
import { I18nextProvider } from 'react-i18next';
import { injectGlobal } from 'styled-components';
import { composeWithDevTools } from 'redux-devtools-extension';
import rootReducer from './reducers/RootReducer';
import rootSaga from './sagas/RootSaga';
import App from './App';
import i18n from './i18n';

const sagaMidelware = createSagaMiddleware();

// Redux devtool often crashes becouse of to large payload, stateSanitizer removing not using state.
const stateSanitizer = state => ({ ...state, auth: null, mapData: null, flightManager: null })

const composeEnhancers = composeWithDevTools({
    stateSanitizer
});

export const store = createStore(rootReducer, composeEnhancers(
  applyMiddleware(sagaMidelware),
));

injectGlobal`
  html,
  body,
  #root {
    margin: 0;
    padding: 0;
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    top: 0;
    display: flex;
    flex-direction: column;
    font-family: 'Open Sans', sans-serif;
  }
`;

sagaMidelware.run(rootSaga);

ReactDOM.render(
  <Provider store={store}>
    <I18nextProvider i18n={i18n}>
      <App />
    </I18nextProvider>
  </Provider>
  , document.getElementById('root'));


// WEBPACK FOOTER //
// ./src/index.js